import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-individual',
  templateUrl: './professional-individual.component.html',
  styleUrls: ['./professional-individual.component.less']
})
export class ProfessionalIndividualComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
